import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"
import Geocode from "react-geocode"
import styled from "styled-components"

import AppInput from "../../../../../../../_shared/components/FormItems/AppInput"
import MapSection, {
    MAPS_API_KEY,
} from "../../../../../../../_shared/components/Map"
import AppHeading from "../../../../../../../_shared/components/Typography/Heading"

const mapsApiKey = MAPS_API_KEY

Geocode.setApiKey(mapsApiKey)
Geocode.setLanguage("it")
Geocode.setRegion("it")
Geocode.setLocationType("ROOFTOP")

// ----------------------------------------------------------------------------

function _Location(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, values, onChange, index } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const timerRef = useRef(null)

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        timerRef.current && clearTimeout(timerRef.current)
        timerRef.current = setTimeout(() => {
            handleAddressChange(
                `${values.address} ${values.city} ${values.province}`
            )
        }, 1000)

        //eslint-disable-next-line
    }, [values.city, values.address, values.province])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleAddressChange(addr) {
        Geocode.fromAddress(addr).then(
            (response) => {
                const { lat, lng } = response.results[0].geometry.location
                onChange("location", { lat, lng })

                const addressComponents = response.results[0].address_components

                const stateComponent = addressComponents.find((component) =>
                    component.types.includes("administrative_area_level_1")
                )

                const state = stateComponent?.long_name || null

                onChange("state", state)
            },
            (error) => {
                // eslint-disable-next-line
                console.log(error)
            }
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <AppHeading className="heading" boldness="bold">
                Location {index + 1} (codice interno {values.code})
            </AppHeading>
            <AppHeading className="heading" boldness="medium">
                Città
            </AppHeading>
            <AppInput
                className="input"
                value={values.city}
                onChange={(e) => onChange("city", e.target.value)}
            />
            <AppHeading className="heading" boldness="medium">
                Indirizzo
            </AppHeading>
            <AppInput
                className="input"
                value={values.address}
                onChange={(e) => onChange("address", e.target.value)}
            />
            <AppHeading className="heading" boldness="medium">
                Provincia
            </AppHeading>
            <AppInput
                className="input"
                value={values.province}
                onChange={(e) => onChange("province", e.target.value)}
            />
            <AppHeading className="heading" boldness="medium">
                Regione
            </AppHeading>
            <AppInput
                className="input"
                value={values.state}
                onChange={(e) => onChange("state", e.target.value)}
                disabled
            />

            {values?.location?.lat && values?.location?.lng && (
                <>
                    <AppHeading className="heading" boldness="medium">
                        Coordinate
                    </AppHeading>
                    <MapSection
                        className="map-picker"
                        marker={values?.location || {}}
                        height={25}
                        zoomLevel={10}
                    />
                </>
            )}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_Location.propTypes = {
    className: PropTypes.string.isRequired,
    values: PropTypes.object,
    onChange: PropTypes.func,
    index: PropTypes.number,
}

_Location.defaultProps = {}

// ----------------------------------------------------------------------------

const Location = styled(_Location)`
    & {
    }
`
// ----------------------------------------------------------------------------

export default Location
